import { render, staticRenderFns } from "./budget.vue?vue&type=template&id=564a29d7&scoped=true&"
import script from "./budget.vue?vue&type=script&lang=ts&"
export * from "./budget.vue?vue&type=script&lang=ts&"
import style0 from "./budget.vue?vue&type=style&index=0&id=564a29d7&prod&lang=sass&scoped=true&"
import style1 from "./budget.vue?vue&type=style&index=1&id=564a29d7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564a29d7",
  null
  
)

export default component.exports